import React, { useCallback } from 'react';
import { AdminDeletePlaceModalProps } from './admin-delete-place-modal-props';
import { AdminModal } from '../admin-modal';
import { AdminModalBody } from '../admin-modal-body';
import { AdminModalButtonFooter } from '../admin-modal-button-footer';
import { AdminModalHeader } from '../admin-modal-header';
import { AdminModalHeading } from '../admin-modal-heading';
import { AdminModalText } from '../admin-modal-text';
import { Button } from '@mint/ui';
import { popAdminModal } from '../../../actions';
import { useDeletePlaceMutation } from '../../../mutations';
import { useDispatch } from 'react-redux';

export const AdminDeletePlaceModal: React.FunctionComponent<
  AdminDeletePlaceModalProps
> = props => {
  const dispatch = useDispatch();

  const [deletePlace] = useDeletePlaceMutation({
    id: props.placeId,
  });

  const onDeleteClick = useCallback(async () => {
    await deletePlace();
    dispatch(popAdminModal());
  }, [deletePlace]);

  const onCancelClick = useCallback(() => {
    dispatch(popAdminModal());
  }, [dispatch]);

  return (
    <AdminModal>
      <AdminModalHeader>
        <AdminModalHeading>Delete Place</AdminModalHeading>
      </AdminModalHeader>
      <AdminModalBody>
        <AdminModalText>
          {props.placeName ? (
            <>
              Are you sure you want to delete the place <b>{props.placeName}</b>
              ?
            </>
          ) : (
            'Are you sure you want to delete this place?'
          )}
        </AdminModalText>
      </AdminModalBody>
      <AdminModalButtonFooter>
        <Button onClick={onCancelClick}>Cancel</Button>
        <Button onClick={onDeleteClick} color="error">
          Yes, Delete Forever
        </Button>
      </AdminModalButtonFooter>
    </AdminModal>
  );
};
